import React from "react";
import { TrendingUp, CheckCircle, X, Award } from "lucide-react";
import { Badge } from "@/components/ui/badge";

const MERCATO = [
  { pacchetto: "Small", foto: "Fino a 10 foto", prezzo: "299", iva: true },
  { pacchetto: "Medium", foto: "Fino a 15-16 foto", prezzo: "499", iva: true },
  { pacchetto: "Large", foto: "Oltre 20-30 foto", prezzo: "849", iva: true },
];

const NOSTRO = {
  prezzo: "499",
  lancio: "LANCIO",
  include: [
    "Pacchetto Start INCLUSO (€99 di valore)",
    "GoPro MAX 360° professionale",
    "Timewarp IN REGALO",
    "15+ foto sferiche ad alta risoluzione",
    "Pubblicazione Google Maps + Street View",
    "Link per sito web e social",
    "Nessun canone mensile",
    "PayPal Paga in 3 rate TAEG 0%",
  ],
};

export const ConfrontoPrezziSection = () => (
  <section className="py-14 bg-[#060a12]" data-testid="confronto-prezzi-section">
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-8">
        <Badge className="bg-[#D4AF37]/15 text-[#F5E6A3] border-[#D4AF37]/30 mb-3 rounded-full px-4 py-1">
          <TrendingUp className="w-4 h-4 mr-2" />
          Confronto Mercato
        </Badge>
        <h2 className="text-2xl md:text-3xl font-black text-white" style={{ fontFamily: "'Poppins',sans-serif" }}>
          Il Miglior <span style={{ background: 'linear-gradient(135deg, #D4AF37, #F5E6A3, #D4AF37)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text' }}>Rapporto Qualita/Prezzo</span> sul Mercato
        </h2>
        <p className="text-gray-400 text-sm mt-2 max-w-2xl mx-auto">
          Il costo medio di un Virtual Tour di un fotografo Google aziendale (Street View Trusted) in Italia parte da ~300€+IVA per piccole attivita'. I prezzi sono una tantum, senza canoni mensili.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-6">
        {/* Prezzi di mercato */}
        <div className="bg-white/[0.03] border border-white/10 rounded-2xl p-6">
          <h3 className="text-white font-bold text-lg mb-4 flex items-center gap-2">
            <span className="text-gray-400">Prezzi medi di mercato</span>
          </h3>
          <div className="space-y-3">
            {MERCATO.map((m, i) => (
              <div key={i} className="flex items-center justify-between py-3 px-4 bg-white/[0.03] rounded-xl border border-white/5">
                <div>
                  <p className="text-white font-bold text-sm">{m.pacchetto}</p>
                  <p className="text-gray-500 text-xs">{m.foto}</p>
                </div>
                <div className="text-right">
                  <span className="text-white font-black text-lg">€{m.prezzo}</span>
                  <span className="text-gray-500 text-xs ml-1">+IVA</span>
                </div>
              </div>
            ))}
            <div className="mt-3 space-y-1.5">
              <div className="flex items-center gap-2 text-xs text-gray-500">
                <X className="w-3.5 h-3.5 text-red-400 flex-shrink-0" />
                <span>Foto standard extra ~€10 l'una</span>
              </div>
              <div className="flex items-center gap-2 text-xs text-gray-500">
                <X className="w-3.5 h-3.5 text-red-400 flex-shrink-0" />
                <span>Ottimizzazione scheda Google Business esclusa</span>
              </div>
              <div className="flex items-center gap-2 text-xs text-gray-500">
                <X className="w-3.5 h-3.5 text-red-400 flex-shrink-0" />
                <span>Timewarp non incluso</span>
              </div>
            </div>
          </div>
        </div>

        {/* Il nostro pacchetto */}
        <div className="relative rounded-2xl p-[2px] overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-r from-[#D4AF37] via-[#F5E6A3] to-[#D4AF37] opacity-60"></div>
          <div className="relative bg-[#0a0a0a] rounded-[14px] p-6 h-full">
            <div className="absolute -top-0 right-4">
              <Badge className="bg-[#D4AF37] text-black font-black text-[10px] px-3 py-1 rounded-b-lg rounded-t-none">
                <Award className="w-3 h-3 mr-1" /> MIGLIOR VALORE
              </Badge>
            </div>
            <h3 className="font-black italic text-xl mb-1" style={{ fontFamily: "'Poppins',sans-serif", background: 'linear-gradient(135deg, #D4AF37, #F5E6A3, #D4AF37, #B8942E)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text' }}>
              Virtual Tour schedabusiness
            </h3>
            <div className="flex items-baseline gap-2 mb-4">
              <span className="text-gray-500 text-lg font-black line-through">€699</span>
              <span className="text-3xl font-black" style={{ background: 'linear-gradient(135deg, #D4AF37, #F5E6A3, #D4AF37)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text' }}>€{NOSTRO.prezzo}</span>
              <Badge className="bg-[#34A853]/20 text-[#34A853] border-[#34A853]/30 text-[10px]">LANCIO</Badge>
            </div>
            <ul className="space-y-2">
              {NOSTRO.include.map((item, i) => (
                <li key={i} className="flex items-start gap-2 text-xs">
                  <CheckCircle className="w-4 h-4 flex-shrink-0 mt-0.5 text-[#D4AF37]" />
                  <span className="text-gray-300">{item}</span>
                </li>
              ))}
            </ul>
            <p className="mt-4 text-[10px] text-gray-500 border-t border-white/10 pt-3">
              Fonte: Register.it, Andrea Chiesa, Progetto Immagine — Prezzi medi fotografi Google certificati Italia 2024-2025. Nessun canone di mantenimento.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default ConfrontoPrezziSection;
